/**
 * Полоска под выбранным разделом — переезжает к новому (16.10.2026).
 *
 * Прежде подчёркивание просто появлялось под другой вкладкой, и смена
 * раздела свайпом читалась рывком. Теперь полоска едет и меняет ширину под
 * название. Где она стояла, запоминается по имени ряда вкладок: «Счета»
 * рисуют свой заголовок, и при переходе на «Платежи» ряд вкладок рождается
 * заново — без памяти полоска появлялась бы на месте, а не приезжала.
 */
import { useLayoutEffect, useRef, useState } from 'react';

type Box = { left: number; width: number };
const last = new Map<string, Box>();

export function TabInk({ row, active }: {
  /** Имя ряда вкладок — у «Денег» и «Аналитики» своя память. */
  row: string;
  /** Выбранный раздел: сменился — полоска едет к нему. */
  active: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const [box, setBox] = useState<Box | null>(() => last.get(row) ?? null);
  useLayoutEffect(() => {
    const place = () => {
      const on = ref.current?.parentElement?.querySelector<HTMLElement>('button.on');
      if (!on) return;
      const next = { left: on.offsetLeft, width: on.offsetWidth };
      last.set(row, next);
      setBox(next);
    };
    // Кадр спустя: с прежнего места полоска успевает встать и поехать, а не прыгнуть.
    const frame = requestAnimationFrame(place);
    window.addEventListener('resize', place);
    void document.fonts?.ready.then(place);
    return () => { cancelAnimationFrame(frame); window.removeEventListener('resize', place); };
  }, [row, active]);
  return <span ref={ref} className="an-ink" aria-hidden="true"
    style={box ? { transform: `translateX(${box.left}px)`, width: box.width } : { opacity: 0 }} />;
}
